import React from 'react';

export const playerContext = React.createContext({
  API: {},
  properties: {},
});
